/**
 * SIGFU REST API
 * Serveur d\'api en NodeJs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EtapePrecedenteDto } from './etapePrecedenteDto';
import { EtapeEncoursDto } from './etapeEncoursDto';
import { EtapeSuivanteDto } from './etapeSuivanteDto';


export interface DemandeDto { 
    /**
     * application code
     */
    transactionCode: string;
    /**
     * application number
     */
    numeroDemande: string;
    /**
     * application type
     */
    typeDemande: string;
    /**
     * reception date
     */
    dateRecu: string;
    /**
     * Previous step
     */
    etapePrecedente?: EtapePrecedenteDto | null;
    /**
     * Step in progress
     */
    etapeEncours: EtapeEncoursDto | null;
    /**
     * Next step
     */
    etapeSuivante?: EtapeSuivanteDto | null;
    /**
     * error code
     */
    codeErreur: string;
    /**
     * error message for UI
     */
    msgErreur: string;
}

